import { gql } from '@apollo/client'

export const UPDATE_PROCESSINGS_MUTATION = gql`
  mutation updateProcessings($ids: [ID!]!, $attributes: ProcessingInput!) {
    updateProcessings(ids: $ids, attributes: $attributes)
  }
`
